import axios from "axios";

let nodeEnv = "prod"            // "dev" or "prod"
const baseURL = nodeEnv === "dev" ? "http://127.0.0.1:5000/api/": "https://rumors.azurewebsites.net/api"

export const servicePath = axios.create({
  baseURL: baseURL
});